import { FragmentOf, graphql, readFragment } from 'gql.tada'

import IconPlus from '@/assets/icons/ic_logic-g-app_plus.svg'
import {
  WebPanel,
  WebPanelItem,
  WebPanelItemContent,
  WebPanelItemLabel,
} from '@/components/web-panel'
import { CurriculumLicenseStatus } from '@/gql/generated/graphql'
import Link from '@/update-monitor/Link'
import { Maybe } from '@/utils/common-types'

interface Props {
  viewer: Maybe<FragmentOf<typeof CurriculumLicenseList_viewer>>
}

export const CurriculumLicenseList = (props: Props): JSX.Element => {
  const viewer = readFragment(CurriculumLicenseList_viewer, props.viewer)
  const curriculumLicenses = viewer?.curriculumLicensesConnection?.edges?.map((edge) => edge?.node)
  const onlySubscription =
    (viewer?.hasSubscription || viewer?.isFreeTrialUser) && !viewer?.hasCurriculumLicense

  return (
    <section className="mx-auto mt-10 max-w-[940px]">
      <div className="mb-2.5 flex justify-between md:mb-3.5 lg:mb-5">
        <h3 className="text-base font-bold md:text-[17px] lg:text-xl">教材</h3>
        <Link
          href="/web/register-new-license-code"
          className="flex items-center text-sm font-bold text-primary-100"
        >
          <IconPlus className="w-[20px] md:w-[24px]" />
          教材を追加
        </Link>
      </div>
      {onlySubscription ? (
        <WebPanel>
          <WebPanelItem>
            <WebPanelItemContent>
              ライセンスコードを入力することで、教材を追加して受講することが可能です
            </WebPanelItemContent>
          </WebPanelItem>
        </WebPanel>
      ) : (
        <WebPanel>
          {curriculumLicenses?.map((curriculumLicense) => (
            <WebPanelItem key={curriculumLicense?.id}>
              <WebPanelItemLabel>教材名</WebPanelItemLabel>
              <WebPanelItemContent>
                <p className="text-sm">{curriculumLicense?.curriculum?.name}</p>
                {(() => {
                  switch (curriculumLicense?.status) {
                    case 'IN_USE':
                      return (
                        <p className="text-xs">
                          {curriculumLicense?.player?.name ?? curriculumLicense.player?.nickname}
                          さんが利用
                        </p>
                      )
                    case 'UNUSED':
                      return <p className="text-xs">未使用</p>
                    case 'EXPIRED':
                      return <p className="text-xs">利用終了</p>
                  }
                })()}
              </WebPanelItemContent>
            </WebPanelItem>
          ))}
        </WebPanel>
      )}
    </section>
  )
}

export const CurriculumLicenseList_viewer = graphql(`
  fragment CurriculumLicenseList_viewer on User {
    id
    hasCurriculumLicense
    hasSubscription
    isFreeTrialUser
    curriculumLicensesConnection {
      edges {
        node {
          id
          status
          curriculum {
            id
            name
          }
          player {
            id
            name
            nickname
          }
        }
      }
    }
  }
`)
